import { useTheme } from '../../context/ThemeContext';

const Skeleton = ({ rows = 5, cols = 5 }) => {
  const { dark } = useTheme();
  const bg = dark ? '#1E293B' : '#F1F5F9';
  return Array.from({ length: rows }, (_, r) => (
    <div key={r} style={{ display: 'flex', gap: 12, padding: '12px 0', borderBottom: `1px solid ${dark ? '#1E293B' : '#F1F5F9'}` }}>
      {Array.from({ length: cols }, (_, c) => (
        <div key={c} style={{ height: 16, background: bg, borderRadius: 6, flex: c === 0 ? 2 : 1, animation: 'pulse 1.5s infinite' }} />
      ))}
    </div>
  ));
};

export default Skeleton;
